<template>
  <div class="wk_producibilita d-flex flex-column w-100">
    <div id="search-bar" class="bg-grey-lighten-3 py-2">
      <div class="wk_searchbar_row large-wrapper" id="search-bar-first-row">
        <v-combobox
            label="color code 1"
            :items="colori1 ? colori1 : search_fields.colori1"
            item-title="CDCOL"
            item-name="CDCOL"
            item-value="CDCOL"
            v-model="selectedColore1"
            class="wk_autocomplete"
            clearable
            hide-no-data
            return-object
            @blur="handleBlur('CDCOL')"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.CDCOL !== '' ? item.raw.CDCOL : 'No code'"
                :subtitle="item.raw.CDCOL_DES ? item.raw.CDCOL_DES : ''"
            ></v-list-item>
          </template>
        </v-combobox>

        <v-combobox
            label="finish code 1"
            :items="sortable_finishes ? sortable_finishes : search_fields.finiture1"
            item-title="CDFIN_DES"
            item-name="CDFIN_DES"
            item-value="CDFIN"
            v-model="selectedFinitura1"
            class="wk_autocomplete"
            :append-inner-icon="sortIcons[sortIconFiniture]"
            @click:append-inner="onSort()"
            clearable
            hide-no-data
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.CDFIN !== '' ? item.raw.CDFIN : 'No code'"
                :subtitle="item.raw.CDFIN_DES ? item.raw.CDFIN_DES : ''"
            ></v-list-item>
          </template>
        </v-combobox>

        <v-combobox
            label="length (mm)"
            :items="lunghezze ? lunghezze : search_fields.lunghezze"
            v-model="selectedLunghezza"
            class="wk_autocomplete"
            clearable
            hide-no-data
        ></v-combobox>

        <v-combobox
            label="thickness (mm)"
            :items="spessori ? spessori : search_fields.spessori"
            v-model="selectedSpessore"
            class="wk_autocomplete"
            clearable
            hide-no-data
        ></v-combobox>

        <v-combobox
            label="type code"
            :items="tipi ? tipi : search_fields.tipi"
            item-title="CDTIP"
            item-name="CDTIP_DES"
            item-value="CDTIP"
            v-model="selectedTipo"
            class="wk_autocomplete"
            clearable
            hide-no-data
            return-object
            @blur="handleBlur('CDTIP')"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.CDTIP !== '' ? item.raw.CDTIP : 'No code'"
                :subtitle="item.raw.CDTIP_DES ? item.raw.CDTIP_DES : ''"
            ></v-list-item>
          </template>
        </v-combobox>

        <v-combobox
            label="collection code"
            :items="collezioni ? collezioni : search_fields.collezioni"
            item-title="GRSTP"
            item-name="GRSTP"
            item-value="GRSTP"
            v-model="selectedCollezione"
            class="wk_autocomplete"
            clearable
            hide-no-data
            return-object
            @blur="handleBlur('GRSTP')"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.GRSTP !== '' ? item.raw.GRSTP : 'No code'"
                :subtitle="item.raw.GRSTP_DES ? item.raw.GRSTP_DES : ''"
            ></v-list-item>
          </template>
        </v-combobox>
      </div>
      <div class="wk_searchbar_row large-wrapper" id="search-bar-second-row">
        <v-combobox
            label="color code 2"
            :items="colori2 ? colori2 : search_fields.colori2"
            item-title="CDCO2"
            item-name="CDCO2"
            item-value="CDCO2"
            v-model="selectedColore2"
            class="wk_autocomplete"
            clearable
            hide-no-data
            return-object
            @blur="handleBlur('CDCO2')"
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.CDCO2 !== '' ? item.raw.CDCO2 : 'No code'"
                :subtitle="item.raw.CDCOL_DES2 ? item.raw.CDCOL_DES2 : ''"
            ></v-list-item>
          </template>
        </v-combobox>

        <v-combobox
            label="finish code 2"
            :items="sortable_finishes ? sortable_finishes : search_fields.finiture1"
            :item-title="sortable_finishes ? 'CDFIN_DES' : 'CDFIN_DES2'"
            :item-name="sortable_finishes ? 'CDFIN_DES' : 'CDFIN_DES2'"
            :item-value="sortable_finishes ? 'CDFIN' : 'CDFI2'"
            v-model="selectedFinitura2"
            class="wk_autocomplete"
            :append-inner-icon="sortIcons[sortIconFiniture]"
            @click:append-inner="onSort()"
            clearable
            hide-no-data
        >
          <template v-slot:item="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="item.raw.CDFIN !== '' ? item.raw.CDFIN : 'No code'"
                :subtitle="item.raw.CDFIN_DES ? item.raw.CDFIN_DES : ''"
            ></v-list-item>
          </template>
        </v-combobox>

        <v-combobox
            label="width (mm)"
            :items="larghezze ? larghezze : search_fields.larghezze"
            v-model="selectedLarghezza"
            class="wk_autocomplete"
            clearable
            hide-no-data
        ></v-combobox>

        <v-combobox
            label="dimension"
            :items="dimensioni ? dimensioni : search_fields.dimensioni"
            v-model="selectedDimensione"
            class="wk_autocomplete"
            clearable
            hide-no-data
        ></v-combobox>
        <div class="d-flex justify-end" id="search-button">
          <v-btn @click="filter()" variant="flat" color="black">Search</v-btn>
          <v-btn @click="reset()" variant="tonal" color="black">Reset</v-btn>
        </div>
      </div>
    </div>

    <v-alert
        class="my-1 large-wrapper"
        v-if="searched && filteredList.length === 0"
        text="No results were found for the current search criteria."
        title="No results"
        type="error"
        density="comfortable"
        closable
    ></v-alert>

    <v-alert
        class="my-1 large-wrapper"
        v-if="
        searched && filteredList.length > 1000 && filteredList.length < 100000
      "
        text="The query returned a result set exceeding 1,000 records. Please apply additional filters to narrow the results."
        title="Warning"
        type="warning"
        density="compact"
        closable
    ></v-alert>

    <v-alert
        class="my-1 large-wrapper"
        v-if="searched && filteredList.length > 99999"
        text="The search exceeded 100,000 results and was automatically limited. Please apply additional search parameters to narrow the result set."
        title="Warning"
        type="warning"
        density="compact"
        closable
    ></v-alert>

    <div
        class="space-top align-center justify-center text-center"
        v-if="loading"
    >
      <v-progress-circular
          :size="70"
          :width="7"
          color="black"
          indeterminate
      ></v-progress-circular>
    </div>

    <DataTable
        v-else
        class="wk_prod_table large-wrapper p-datatable-sm"
        style="font-size: 0.875rem"
        v-show="filteredList.length > 0"
        :value="filteredList"
        :reorderable-columns="true"
        resizableColumns
        columnResizeMode="expand"
        stripedRows
        paginator
        :rows="50"
        :totalRecors="filteredList.length"
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
        scrollable
        scrollHeight="80vh"
    >
      <template #header>
        <!--        <div class="wk_searchbar">-->
        <!--          <InputText-->
        <!--            v-model="filters['global'].value"-->
        <!--            placeholder="Ricerca globale"-->
        <!--          />-->
        <!--        </div>-->
        <div class="wk_columns_select text-right">
          Seleziona le colonne:
          <MultiSelect
              :modelValue="selectedColumns"
              :options="headerList"
              optionLabel="header"
              @update:modelValue="onToggle"
              :maxSelectedLabels="5"
              class="ma-1"
          />
        </div>
      </template>

      <Column
          v-for="(col, index) of selectedColumns"
          :key="col.key + '_' + index"
          :field="col.field"
          :header="col.header"
          sortable
      >
        <template #body="{ data }">
          {{ printColumn(col.field, data) }}
        </template>
      </Column>
    </DataTable>
  </div>

  <v-snackbar v-model="snackbar" :timeout="defaultTimeout()">
    {{ text }}

    <template v-slot:actions>
      <v-btn color="white" variant="text" @click="snackbar = false"
      >Close
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style lang="scss" scoped>
@use "@/styles/styles" as *;

.wk_producibilita {
  padding-bottom: 100px;
}

.large-wrapper {
  margin: 0 auto;
  width: 90%;
}

#search-button {
  width: 33.33%;
  max-width: calc(33.33% - 20px);
  margin: 20px 10px;
}

.space-top {
  margin-top: 80px;
}

.wk_searchbar_row {
  display: flex;
  justify-content: flex-start;
}

.wk_searchbar {
  display: flex;
  justify-content: center;
  margin: 25px 0;

  input {
    min-width: 250px;
  }
}

.wk_autocomplete {
  max-width: calc(16.666% - 20px);
  margin: 0 10px;
}

.v-data-table-header__content span {
  font-weight: 600;
}

// remove margin bottom 100px
.p-datatable.p-component.p-datatable-responsive-scroll {
  margin-bottom: 0;
}

.wk_columns_select .p-multiselect .p-multiselect-label {
  padding: 10px !important;
}
</style>

<script>
import axios from "axios";
import search_fields_json from "../data/search_fields_prod.json";
import {API_URL, defaultTimeout} from "@/utils/const";
import authHeader from "@/services/data.service";
import {FilterMatchMode} from "primevue/api";
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      ready: false,
      clearable: true,
      loading: false,
      // data from APIs
      search_fields: {
        tipi: [],
        colori1: [],
        colori2: [],
        finiture: [],
        finiture1: [],
        finiture2: [],
        spessori: [],
        dimensioni: [],
        lunghezze: [],
        larghezze: [],
        collezioni: [],
      },
      sortable_finishes: [],
      // selected data
      selectedTipo: null,
      selectedColore1: null,
      selectedColore2: null,
      selectedFinitura1: null,
      selectedFinitura2: null,
      selectedSpessore: null,
      selectedDimensione: null,
      selectedLunghezza: null,
      selectedLarghezza: null,
      selectedCollezione: null,
      selectedColumns: [],
      headerList: [
        {field: "CDTIP", header: "Cod. Type"},
        {field: "CDCOL", header: "Col. 1"},
        {field: "CDFIN", header: "Fin. 1"},
        {field: "SPESS", header: "Thick. (mm)"},
        {field: "CDDIM", header: "Dimension"},
        {field: "LNGDM", header: "Length (mm)"},
        {field: "LRGDM", header: "Width. (mm)"},
        {field: "CDCO2", header: "Col. 2"},
        {field: "CDFI2", header: "Fin. 2"},
        {field: "GRSTP", header: "Collection"},
      ],
      filteredList: [],
      search: "",
      searched: false,
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        CDTIP: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDTIP_DES: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDFIN: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDFIN_DES: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDFI2: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDFIN_DES2: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDCOL: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDCOL_DES: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDCO2: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDCOL_DES2: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        SPESS: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        CDDIM: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        LNGDM: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        LRGDM: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        GRSTP: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
        TIPST: {value: null, matchMode: FilterMatchMode.STARTS_WITH},
      },
      sortIcons: ['mdi-sort-ascending', 'mdi-sort-alphabetical-ascending', 'mdi-sort-alphabetical-ascending'],
      sortIconFiniture: 0,
      snackbar: false,
      text: ""
    };
  },
  computed: {
    // ...mapGetters("fields", ["getField"]),
    ...mapGetters("fields", ["tipi"]),
    ...mapGetters("fields", ["colori1"]),
    ...mapGetters("fields", ["colori2"]),
    ...mapGetters("fields", ["finiture"]),
    ...mapGetters("fields", ["finiture1"]),
    ...mapGetters("fields", ["finiture2"]),
    ...mapGetters("fields", ["spessori"]),
    ...mapGetters("fields", ["dimensioni"]),
    ...mapGetters("fields", ["lunghezze"]),
    ...mapGetters("fields", ["larghezze"]),
    ...mapGetters("fields", ["collezioni"]),
  },
  async mounted() {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title;
    }

    this.loading = true;

    await this.$store.dispatch("fields/fetchAll");

    if (this.finiture) {
      this.sortable_finishes = this.finiture;
    }

    this.search_fields = search_fields_json;

    this.selectedColumns = this.headerList;

    this.loading = false;
  },
  methods: {
    defaultTimeout() {
      return defaultTimeout;
    },
    async filter() {
      this.loading = true;
      this.searched = false;

      const queryParams = {
        tipo: this.selectedTipo ? this.selectedTipo.CDTIP : null,
        colore1: this.selectedColore1 ? this.selectedColore1.CDCOL : null,
        colore2: this.selectedColore2 ? this.selectedColore2.CDCO2 : null,
        finitura1: this.selectedFinitura1 ? this.selectedFinitura1.CDFIN : null,
        finitura2: this.selectedFinitura2 ? this.selectedFinitura2.CDFI2 : null,
        dimensione: this.selectedDimensione,
        spessore: this.selectedSpessore,
        lunghezza: this.selectedLunghezza,
        larghezza: this.selectedLarghezza,
        collezione: this.selectedCollezione ? this.selectedCollezione.GRSTP : null,
      };
      await axios
          .get(API_URL + "prod/records/filter", {
            headers: authHeader(),
            params: queryParams,
          })
          .then((response) => {
            if (response.data) {
              this.filteredList = response.data.filter((record) => {
                // remove record that has status 4 or 5
                return record.TIPST < 4;
              });
            } else {
              this.filteredList = {};
            }
          })
          .catch((error) => {
            console.error("Error while getting the search result", error);
          });

      this.loading = false;
      this.searched = true;
    },
    onToggle(value) {
      this.selectedColumns = this.headerList.filter((col) =>
          value.includes(col)
      );
    },
    onSort() {
      if (!this.sortable_finishes) {
        this.text = "Cannot load the finishes. Please reload the page.";
        this.snackbar = true;
        return;
      }

      if (this.sortIconFiniture === 2) {
        this.sortIconFiniture = 0;
        this.sortable_finishes.sort((a, b) => { return a.index - b.index; });

        this.text = "Finishes sorted by index";
        this.snackbar = true;
      } else {
        this.sortIconFiniture++;

        if (this.sortIconFiniture === 1) {
          this.sortable_finishes.sort((a, b) => { return a.CDFIN.localeCompare(b.CDFIN); });

          this.text = "Finishes ordered by finish codes (A-Z)";
          this.snackbar = true;
        } else {
          this.sortable_finishes.sort((a, b) => { return a.CDFIN_DES.localeCompare(b.CDFIN_DES) });

          this.text = "Finishes ordered by finish descriptions (A-Z)";
          this.snackbar = true;
        }
      }
    },
    reset() {
      this.selectedTipo = null;
      this.selectedColore1 = null;
      this.selectedColore2 = null;
      this.selectedFinitura1 = null;
      this.selectedFinitura2 = null;
      this.selectedDimensione = null;
      this.selectedSpessore = null;
      this.selectedLunghezza = null;
      this.selectedLunghezza = null;
      this.selectedCollezione = null;
      this.filteredList = [];
      this.searched = false;
    },
    handleBlur(field) {
      switch (field) {
        case "CDCOL":
          if (typeof this.selectedColore1 === "string") {
            this.selectedColore1 = {
              CDCOL: this.selectedColore1,
              CDCOL_DES: "",
            };
          }
          break;
        case "CDCO2":
          if (typeof this.selectedColore2 === "string") {
            this.selectedColore2 = {
              CDCO2: this.selectedColore2,
              CDCOL_DES2: "",
            };
          }
          break;
        case "CDFIN":
          if (typeof this.selectedFinitura1 === "string") {
            this.selectedFinitura1 = {
              CDFIN: this.selectedFinitura1,
              CDFIN_DES: "",
            };
          }
          break;
        case "CDFI2":
          if (typeof this.selectedFinitura2 === "string") {
            this.selectedFinitura2 = {
              CDFI2: this.selectedFinitura2,
              CDFI2_DES: "",
            };
          }
          break;
        case "CDTIP":
          if (typeof this.selectedTipo === "string") {
            this.selectedTipo = {
              CDTIP: this.selectedTipo,
              CDTIP_DES: "",
            }
          }
          break;
        case "GRSTP":
          if (typeof this.selectedCollezione === "string") {
            this.selectedCollezione = {
              GRSTP: this.selectedCollezione,
              GRSTP_DES: "",
            }
          }
          break;
        default:
          break;
      }
    },
    printColumn(field, data) {
      switch (field) {
        case "CDFIN":
          return data.CDFIN_DES
              ? data.CDFIN + " - " + data.CDFIN_DES
              : data.CDFIN;
        case "CDCOL":
          return data.CDCOL_DES
              ? data.CDCOL + " - " + data.CDCOL_DES
              : data.CDCOL;
        case "CDFI2":
          return data.CDFIN_DES2
              ? data.CDFI2 + " - " + data.CDFIN_DES2
              : data.CDFI2;
        case "CDCO2":
          return data.CDCOL_DES2
              ? data.CDCO2 + " - " + data.CDCOL_DES2
              : data.CDCO2;
        case "GRSTP":
          return data.GRSTP_DES
              ? data.GRSTP + " - " + data.GRSTP_DES
              : data.GRSTP;
        case "CDTIP":
          return data.CDTIP
              ? data.CDTIP + " - " + data.CDTIP_DES
              : data.CDTIP;
        default:
          return data[field];
      }
    },
  },
};
</script>
